export const adminNotificationsConstants = {
  ADMIN_NOTIFICATIONS_UPDATE_REQUEST: "ADMIN_NOTIFICATIONS_UPDATE_ONE_REQUEST",
  ADMIN_NOTIFICATIONS_UPDATE_SUCCESS: "ADMIN_NOTIFICATIONS_UPDATE_ONE_SUCCESS",
  ADMIN_NOTIFICATIONS_GET_ALL_REQUEST: "ADMIN_NOTIFICATIONS_GET_ALL_REQUEST",
  ADMIN_NOTIFICATIONS_GET_ALL_SUCCESS: "ADMIN_NOTIFICATIONS_GET_ALL_SUCCESS",
  ADMIN_NOTIFICATIONS_CLEAR: "ADMIN_NOTIFICATIONS_CLEAR",
};
